import client from './client'
import config from '../const'

export default {
  login: (authInfo) => {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams()
      params.append('login_id', authInfo.login_id)
      params.append('login_pass', authInfo.login_pass)
      client
        .post(config.BASE_API_URL + '/user/login', params)
        .then((res) => {
          console.log('auth.js login then', res)
          if (
            typeof res === 'object' &&
            typeof res.data === 'object' &&
            res.data.status == '200'
          ) {
            resolve({
              token: res.data.body.token,
              userId: res.data.body.userId,
              label: res.data.body.label,
              type: res.data.body.type,
              // level: res.data.body.level,
              // relations: res.data.body.relations
            })
          } else {
            // alert('login error')
            reject(new Error('error'))
          }
        })
        .catch((err) => {
          console.log('auth.js login erro ', err)
          reject(new Error(err || err.response.message || err.message))
        })
    })
  },
  licenseLogin: (authInfo) => {
    return new Promise((resolve, reject) => {
      //   client.post('/auth/login', authInfo)
      // console.log('authinfo', authInfo);
      let params = new URLSearchParams()
      params.append('license_no', authInfo.license_no)
      params.append('login_pass', authInfo.login_pass)
      client
        .post(config.BASE_API_URL + '/user/license_login', params)
        .then((res) => {
          console.log('auth.js login then', res)
          if (
            typeof res === 'object' &&
            typeof res.data === 'object' &&
            res.data.status == '200'
          ) {
            resolve({
              token: res.data.body.token,
              userId: res.data.body.userId,
              label: res.data.body.label,
              type: res.data.body.type,
              // level: res.data.body.level,
              // relations: res.data.body.relations
            })
          } else {
            alert('login error')
            reject(new Error('error'))
          }
        })
        .catch((err) => {
          console.log('auth.js login erro ', err)
          reject(new Error(err || err.response.message || err.message))
        })
    })
  },
  tokenLogin: (authInfo) => {
    return new Promise((resolve, reject) => {
      //   client.post('/auth/login', authInfo)
      // console.log('authinfo', authInfo);
      let params = new URLSearchParams()
      const headersParam = {
        headers: { [config.BASE_API_USER_HEADER_KEY]: authInfo.token },
      }
      client
        .post(config.BASE_API_URL + '/user/check', params, headersParam)
        .then((res) => {
          console.log('auth.js tokenLogin then', res)
          if (res.data && res.data.body) {
            resolve({
              token: res.data.body.token,
              userId: res.data.body.userId,
              label: res.data.body.label,
              type: res.data.body.type,
              // level: res.data.body.level,
              // relations: res.data.body.relations
            })
          } else {
            resolve({
              token: '',
              userId: '',
              label: '',
              type: '',
              level: '',
              relations: [],
            })
          }
        })
        .catch((err) => {
          console.log('auth.js login erro ', err)
          reject(new Error(err.response.message || err.message))
        })
    })
  },
  logout: (token) => {
    return new Promise((resolve, reject) => {
      const header = {
        [config.BASE_API_USER_HEADER_KEY]: token,
      }
      console.log('auth.js logout token', header, token)
      client
        .get(config.BASE_API_URL + '/user/logout', { headers: header })
        .then((res) => {
          console.log('auth.js logout client get then res', res)
          resolve()
        })
        .catch((err) => {
          console.log('auth.jslogout err ', err)
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },
}
